import { loadSlots, logAdMessage } from '@utils/ads'
import nanoid from '@utils/random'
import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

export type UseAds = () => {
  areAdSlotsLoaded: () => boolean
  updateAreAdSlotsLoaded: (areAdSlotsLoaded: boolean) => void
  loadAllSlots: () => void
  triggerAdRegistration: () => void
}

const useAds: UseAds = () => {
  const queryClient = useQueryClient()

  const areAdSlotsLoaded = useCallback(() => {
    return queryClient.getQueryData<boolean>('areAdSlotsLoaded') as boolean
  }, [queryClient])

  const updateAreAdSlotsLoaded = useCallback(
    (areAdSlotsLoadedValue: boolean) => {
      queryClient.setQueryData('areAdSlotsLoaded', areAdSlotsLoadedValue)
      queryClient.invalidateQueries('areAdSlotsLoaded', { exact: true })
    },
    [queryClient]
  )

  const triggerAdRegistration = useCallback(() => {
    const randomCode = nanoid()
    logAdMessage(`ADS: initCode: ${randomCode}`)
    queryClient.setQueryData('RiAdTagManagerInitCode', randomCode)
    queryClient.invalidateQueries('RiAdTagManagerInitCode', { exact: true })
  }, [queryClient])

  return {
    areAdSlotsLoaded,
    updateAreAdSlotsLoaded,
    loadAllSlots: loadSlots,
    triggerAdRegistration,
  }
}

export default useAds
